import React, { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';

import {
  Box,
  Button,
  Divider,
  Drawer,
  styled,
  Typography,
} from '@mui/material';

import { AppDispatch } from '../../../../app/store';
import { FlexRow, Spacer } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { manualPia } from '../../detailSlice';
import styles from '../styles.module.scss';

export const ReviewPiaDrawer = ({
  applicationId,
  isOpen,
  setIsOpen,
  setIsReview,
  reason,
  policy,
}: {
  applicationId: number;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsReview: Dispatch<SetStateAction<boolean>>;
  reason: string;
  policy: string;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">{Resource.INITIATE_PIA}</Typography>
          <Button onClick={() => setIsReview(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              Back
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          {reason && reason.length > 0 && (
            <>
              <FlexRow className={styles.DrawerSubTitle}>
                {Resource.POLICY_NUMBER}
              </FlexRow>
              <Spacer height={8} />
              <FlexRow>
                <span className={styles.Info}>{policy}</span>
              </FlexRow>
              <Spacer height={24} />
              <FlexRow className={styles.DrawerSubTitle}>
                {Resource.REASON}
              </FlexRow>
              <Spacer height={8} />
              <FlexRow>
                <span className={styles.Info}>{reason}</span>
              </FlexRow>
            </>
          )}
        </Box>
        <FixedButtonWrapper>
          <FixedButton
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => {
              dispatch(manualPia(applicationId, reason));
              setIsOpen(false);
            }}
          >
            {Resource.INITIATE_PIA}
          </FixedButton>
        </FixedButtonWrapper>
      </Box>
    </Drawer>
  );
};

const FixedButtonWrapper = styled(Box)(() => ({
  position: 'fixed',
  right: '24px',
  bottom: 0,
  zIndex: 4,
  width: 'calc(375px - 48px)',
}));

const FixedButton = styled(Button)(() => ({
  textTransform: 'none',
  height: '56px',
  marginBottom: '24px',
}));
